module.exports = __webpack_public_path__ + "static/media/banner_1_text.6d86307f.PNG";